const config = {
  // API
  apiBaseUrl: process.env.REACT_APP_API_BASE_URL,
  imageBaseUrl: process.env.REACT_APP_IMAGE_BASE_URL,

  // Google
  google: {
    clientId: process.env.REACT_APP_GOOGLE_CLIENT_ID,
  },

  microsoft: {
    clientId: process.env.REACT_APP_MICROSOFT_CLIENT_ID,
    tenantId: process.env.REACT_APP_MICROSOFT_TENANT_ID,
  },
};

export default config;
